import React from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer text-center text-lg-start text-white bg-dark">
      <div className="container p-4">
        <div className="row">
          {/* Company Info */}
          <div className="col-md-4 mb-4">
            <h6 className="text-uppercase fw-bold mb-3">Mediasha Services</h6>
            <p className="text-light">
              Providing quality products with the best service.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h6 className="text-uppercase fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li><a href="/" className="footer-link text-white text-decoration-none">Home</a></li>
              <li><a href="/about" className="footer-link text-white text-decoration-none">About</a></li>
              <li><a href="/products" className="footer-link text-white text-decoration-none">Products</a></li>
              <li><a href="/contact-us" className="footer-link text-white text-decoration-none">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-4 mb-4">
            <h6 className="text-uppercase fw-bold mb-3">Contact</h6>
            <p><FaEnvelope className="me-2" /> mediasha865@gmail.com</p>
            <p><FaPhone className="me-2" /> +91 958 631 4428</p>
            <p><FaPhone className="me-2" /> +91 888 275 6347</p>
          </div>
        </div>
      </div>

      <div className="text-center p-3 bg-secondary">
        © {new Date().getFullYear()} Mediasha Services. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
